export default __webpack_public_path__ + "static/media/img (1).3c2d61a9.jpg";